import { Entity } from "./entity";

export class Applicazione extends Entity {
    // @field() @pk()
    // oid: number
    Guid: string;
    Nome: string;
    Descrizione: string;
    Url?: string;
    inactive: boolean;
    Username?: string;
    Type: AppType;
}

export enum AppType {
    IFORFETTARI,
    BUDGET4U,
    CONVSRL,
    EASYSTART
}

export const apps: Partial<Applicazione>[] = [{
        Type: AppType.IFORFETTARI,
        Guid: 'DBE4A355-F85E-4911-96EA-36330E2CBEF3',
        // url: window.location.host.includes('localhost') ? 'https://iforf_test.sixtemacloud.it' : window.location.host.includes('wki-') ? 'https://wki-iforf.sixtemacloud.it' : 'https://iforf.sixtemacloud.it',
        Nome: window.location.host.includes('wki-') ? 'Convenienza forfetario' : 'iForfetari',
        Descrizione: 'Una soluzione duttile, semplice ed efficace per guidare le imprese e i professionisti alla scelta del regime fiscale.'
    }, 
    {
        Type: AppType.EASYSTART,
        Guid: '41416934-83D0-41E2-976B-4821E13C8462',
        //     41416934-83D0-41E2-976B-4821E13C8462
        //Url: 'https://easystart.sixtema.it/index.php',
        Url: 'https://easystart.sixtema.it',
        Nome: 'EasyStart',
        Descrizione: 'La consulenza d\'impresa in un click.'
    }, 
    {
        Type: AppType.BUDGET4U,
        Guid: '79C7462F-F461-4918-811D-A75AF852226F',
        // url: window.location.host.includes('localhost') ? 'https://iforf_test.sixtemacloud.it' : window.location.host.includes('wki-') ? 'https://wki-budget4u.sixtemacloud.it' : 'https://budget4u.sixtemacloud.it',        
        Nome: window.location.host.includes('wki-') ? 'Simulazione carico fiscale' : 'Budget4u',
        Descrizione: 'Il tuo budget disponibile analizzando imposte, tasse e contributi previdenziali e assistenziali.'
    }, 
    {
        Type: AppType.CONVSRL,
        Guid: '8DB6B799-2A17-490D-804A-20D51A40D3B3',
        // url: window.location.host.includes('localhost') ? 'https://iforf_test.sixtemacloud.it' : window.location.host.includes('wki-') ? 'https://wki-convsrl.sixtemacloud.it' : 'https://convsrl.sixtemacloud.it',        
        Nome: window.location.host.includes('wki-') ? 'Convenienza srl' : 'Conv Srl',
        Descrizione: 'Le scelte convenienti per l\'impresa Srl. Simulazione del carico fiscale e contributivo per una Srl a ristretta base societaria.'
    }
];